import React, { useEffect, useState, createRef } from 'react'
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { editUserSchool } from '../../actions/usersActions'
import Swal from 'sweetalert2'
import { getSchool } from '../../actions/schoolsActions'
import Select from "react-select"
import provinces from '../../components/provinces.json'
import towns from '../../components/towns.json'
import { useNavigate, useParams } from 'react-router-dom'
import values from '../../components/values.json'
import services from '../../components/services.json'
import lines from '../../components/lines.json'

import { Editor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { EditorState, ContentState, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
import SubMenuSchool from '../../components/menus/SubMenuSchool'

export default function EditSchool() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const params = useParams()
    const fileRef = createRef("<HTMLInputElement>")

    const {school, schooluser} = useSelector(state=>state.schools)
    const {resultuser} = useSelector(state=>state.users)

    const [formState, setFormState] = useState({})

    const [provinceAux, setProvinceAux] = useState({label: '', value: ''});
    const [townAux, setTownAux] = useState({label: '', value: ''});
    const [townsAux, setTownsAux] = useState([]);
    const [imageAux, setImage] = useState(null)

    const [valuesSelect, setValuesSelect] = useState({options: values?.map(value => {
        return {label: t('values.'+value), value: value}
    }), selected : []})

    const [servicesSelect, setServicesSelect] = useState({options: services?.map(service => {
        return { label: t('services.' + service), value: service }
    }), selected: []})

    const [linesSelect, setLinesSelect] = useState({options: lines?.map(line => {
        return { label: t('school.lines.' + line), value: line }
    }), selected: []})

    const [biographyEditorState, setBiographyEditorState] = useState(EditorState.createEmpty())

    useEffect(() => {
        if(params){
            dispatch(getSchool(params?.id))
        }
    },[dispatch, params])

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleSelectTownChange = (target)=>{
        setFormState({
            ...formState,
            'town': target.value
        })
        setTownAux(towns.filter(town => town.value === target.value && formState.province === town.parent_value))

    }

    const [schoolTypeSelect, setSchoolTypeSelect] = useState({
        options: [
            { label: t('school.typeschool.charter'), value: 'charter' },
            { label: t('school.typeschool.private'), value: 'private' }
        ],
        selected: { label: '', value: '' }
    })

    const handleSelectProvinceChange = (target)=>{
        setFormState({
            ...formState,
            'province': target.value,
            'town': ''
        })
        setProvinceAux(provinces.filter(province => province.value === target.value))
        setTownAux({label: '', value: ''})
        setTownsAux(towns.filter(town => town.parent_value === target.value))
    }

    const handleSelectValuesChange = (values) =>{
        if(values.length < 6){
            setValuesSelect({...valuesSelect, selected: values})
            setFormState({
                ...formState,
                'values': values.map(valor => {
                    return valor.value
                })
            })
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('users.maxvaluesselected')
            })
        }
    }

    const handleSelectServicesChange = (services) =>{
        setServicesSelect({...servicesSelect, selected: services})
        setFormState({
            ...formState,
            'services': services.map(service => {
                return service.value
            })
        })
    }

    const handleSelectLinesChange = (lines) =>{
        setLinesSelect({...linesSelect, selected: lines})
        setFormState({
            ...formState,
            'lines': lines.map(line => {
                return line.value
            })
        })
    }

    const handleSelectSchoolTypeChange = (selectedOption) => {
        setSchoolTypeSelect({ ...schoolTypeSelect, selected: selectedOption });
        setFormState({
            ...formState,
            'typeschool': selectedOption.value
        })
    }

    const changeImage = (e) => {
        setImage(e.target.files[0])
    }

    const handleAdd = async(e) => {
        e.preventDefault()

        if(formState.town !== null && formState.province !== null && formState.town !== '' && formState.province !== '' && formState.town !== undefined && formState.province !== undefined){
            dispatch(editUserSchool(imageAux, formState, params?.id))
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('users.pleasecomplete')
            })
        }
    }

    useEffect(() => {
        if(school){
            setFormState({
                name: school.name,
                code: school.code,
                phone: school.phone,
                address: school.address,
                town: school.town,
                province: school.province,
                marketing: school.marketing,
                biography: school.biography,
                values: school.values || [],
                services: school.services || [],
                lines: school.lines || [],
                linkedin: school.linkedin,
                typeschool: school.typeschool || '',
                notifications: schooluser?.notifications,
                image: schooluser?.image,
                email: schooluser?.email,
                web: school.web,
            })

            if(school.province !== null && school.town !== null){
                setProvinceAux(provinces.filter(province => province.value === school.province))
                setTownsAux(towns.filter(town => town.parent_value === school.province))
                setTownAux(towns.filter(town => town.value === school.town && formState.province === school.province))
            }else{
                setProvinceAux(null)
                setTownAux(null)
            }

            setSchoolTypeSelect({
                ...schoolTypeSelect,
                selected: school.typeschool ? schoolTypeSelect.options.find(option => option.value === school.typeschool) : { label: '', value: '' }
            })

            setValuesSelect({...valuesSelect, selected: school.values?.map(value => {
                return {label: t('values.'+value), value: value}
            })})

            setServicesSelect({...servicesSelect, selected: school.services?.map(service => {
                return { label: t('services.' + service), value: service }
            })})

            setLinesSelect({...linesSelect, selected: school.lines?.map(line => {
                return { label: t('school.lines.' + line), value: line }
            })})

            setImage(school.image)

            if (school.biography) {
                const blocksFromHtml = htmlToDraft(school.biography)
                const { contentBlocks, entityMap } = blocksFromHtml

                setBiographyEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(contentBlocks, entityMap)))
            }
        }
    // eslint-disable-next-line
    }, [school, schooluser])

    useEffect(() => {
        if(resultuser){
            switch (resultuser) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('users.schooledit')
                    })
                    navigate('/multischool/schools')
                    break;
                case 'email':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('users.emailduplicate')
                    })
                    break;
                case 'code':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('users.codeduplicate')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultuser])

    const handlebiographyChange = (biography) => {
        setBiographyEditorState(biography)

        setFormState({
            ...formState,
            biography: draftToHtml(convertToRaw(biography.getCurrentContent()))
        })
    }

    return (
        <>
            <Container className='cuerpo'>
                <Row className='mb-4'>
                    <Col className='d-flex align-items-center'>
                        <img src="/images/menus/user.svg" alt="Icono Perfil" />
                        <h1 className='ms-2 m-0'>{t('dashboard.candidate.school')}</h1>
                    </Col>
                </Row>
                <Form onSubmit={handleAdd}>
                    <Row className="mt-2">
                        <Col>
                            <Card className='mb-5 sombra'>
                                <Card.Body className='px-5 pt-5'>
                                    <SubMenuSchool school={school} schoolId={params.id} section="generalData"/>
                                    <Row className="mt-3 mb-4">
                                        <Col xs='12' className='d-flex align-items-center'>
                                            <div className='avatar me-2'>
                                                {imageAux
                                                    ?
                                                        <img className="img-profile" alt="Preview" src={typeof imageAux === 'string' ? imageAux : URL.createObjectURL(imageAux)} />
                                                    :
                                                        formState.image
                                                            ?
                                                                <img className="img-profile" alt="Preview" src={typeof formState.image === 'string' ? formState.image : URL.createObjectURL(formState.image)} />
                                                            :
                                                                <img className='img-profile' alt="Avatar" src="/images/avatar-empty.svg" />
                                                }
                                                <input
                                                    className='custom-file-input'
                                                    style={{ display: 'none' }}
                                                    ref={fileRef}
                                                    type="file"
                                                    name="myImage"
                                                    onChange={changeImage}
                                                />
                                            </div>
                                            <div className="cursor" onClick={() => fileRef?.current?.click()}>{t('users.image')}</div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className='mb-2'>
                                            <Form.Label htmlFor='typeschool'>{t('school.typeschool.title')}</Form.Label>
                                            <Select
                                                className='select'
                                                name='typeschool'
                                                value={schoolTypeSelect.selected}
                                                options={schoolTypeSelect.options}
                                                onChange={handleSelectSchoolTypeChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label htmlFor='name'>{t('users.name')}</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='name'
                                                value={formState.name ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label htmlFor='code'>{t('users.code')}</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='code'
                                                value={formState.code ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className="mt-2 mb-0">
                                            <Form.Label htmlFor='province'>{t('users.province')}</Form.Label>
                                            <Select
                                                className="select"
                                                name={'province'}
                                                options={provinces.sort((a, b) => {
                                                        if (a.label < b.label) {
                                                            return -1
                                                        }
                                                        if (a.label > b.label) {
                                                            return 1
                                                        }
                                                        return 0
                                                    })}
                                                value={provinceAux || null}
                                                onChange={(e) => handleSelectProvinceChange(e)}
                                                required
                                            />
                                            <input
                                                tabIndex={-1}
                                                autoComplete="off"
                                                style={{ opacity: 0, height: 0 }}
                                                value={formState.province || ''}
                                                required
                                                readOnly
                                            />
                                        </Col>
                                        <Col xs='12' lg='6' className="mt-2 mb-0">
                                            <Form.Label htmlFor='town'>{t('users.town')}</Form.Label>
                                            <Select
                                                className="select"
                                                name={'town'}
                                                options={townsAux}
                                                value={townAux || null}
                                                onChange={(e) => handleSelectTownChange(e)}
                                                required
                                            />
                                            <input
                                                tabIndex={-1}
                                                autoComplete="off"
                                                style={{ opacity: 0, height: 0 }}
                                                value={formState.town || ''}
                                                required
                                                readOnly
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className="mt-0 mb-2">
                                            <Form.Label>{t('users.address')}</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='address'
                                                value={formState.address ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                        <Col xs='12' lg='6' className="mt-0 mb-2">
                                            <Form.Label>{t('users.phone')}</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='phone'
                                                value={formState.phone ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label htmlFor='values'>{t('profile.school.choosevalues')}</Form.Label>
                                            <Select
                                                className="select"
                                                name='values'
                                                options={valuesSelect?.options}
                                                value={valuesSelect?.selected?.sort((a, b) => {
                                                        if (a.label < b.label) {
                                                            return -1
                                                        }
                                                        if (a.label > b.label) {
                                                            return 1
                                                        }
                                                        return 0
                                                    })}
                                                onChange={handleSelectValuesChange}
                                                isMulti
                                                required
                                            />
                                        </Col>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label htmlFor='services'>{t('users.chooseservices')}</Form.Label>
                                            <Select
                                                className="select"
                                                name='services'
                                                options={servicesSelect?.options}
                                                value={servicesSelect?.selected}
                                                onChange={handleSelectServicesChange}
                                                isMulti
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label htmlFor='lines'>{t('users.chooselines')}</Form.Label>
                                            <Select
                                                className="select"
                                                name='lines'
                                                options={linesSelect?.options}
                                                value={linesSelect?.selected}
                                                onChange={handleSelectLinesChange}
                                                isMulti
                                                required
                                            />
                                        </Col>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label>{t('signin.email')}</Form.Label>
                                            <Form.Control
                                                type='email'
                                                name='email'
                                                value={formState.email ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label>{t('signin.password')}</Form.Label>
                                            <Form.Control
                                                type='password'
                                                name='password'
                                                value={formState.password ||  ''}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                        <Col xs='12' lg={6} className="my-2">
                                            <Form.Label>{t('profile.school.havelinkedin')}</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='linkedin'
                                                value={formState.linkedin ||  ''}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg={6} className="my-2">
                                            <Form.Label>{t('profile.school.web')}</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='web'
                                                value={formState.web ||  ''}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="my-2">
                                            <Form.Label htmlFor='biography'>{t('users.biographyschool')}</Form.Label>
                                            <Editor
                                                name='biography'
                                                toolbar={{
                                                    options: ['inline', 'list', 'textAlign', 'link'],
                                                    inline: { options: ['bold', 'italic', 'underline'] },
                                                    list: { options: ['unordered', 'ordered'] },
                                                    textAlign: { options: [] },
                                                    link: { options: ['link', 'unlink'] }
                                                }}
                                                editorState={biographyEditorState}
                                                onEditorStateChange={handlebiographyChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="my-3 d-flex justify-content-end">
                                        <Col xs='12' lg='4'>
                                            <Button type="submit" className="btn-primary w-100 my-2">{t('config.school.updateuser')}</Button>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Form>
            </Container>
        </>
    )
}